import blue from '@assets/promos/blue.svg';
import green from '@assets/promos/green.svg';
import lightBlue from '@assets/promos/lightBlue.svg';
import yellow from '@assets/promos/yellow.svg';
import { useTheme } from '@emotion/react';
import { FaWhatsapp } from 'react-icons/fa';
import { ConditionalWrapper } from '@presentation/utils';
import { CountryCode } from '@gql/graphql';
import { useRouter } from '@application/utils';
import type { LocationDescriptor } from 'history';
import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../Button';
import type { ButtonColor } from '../Button';
import * as Styled from './styled';
import type { CardItemPromoProps } from './types';

export * from './types';

export const CardItemPromo: FC<CardItemPromoProps> = (props) => {
  const { theme: cardTheme, title, link, onClick } = props;
  const theme = useTheme();
  const { translate, countryCode } = useRouter();

  // To not turn keys into objects
  // prettier-ignore
  const IMAGES = {
  'blue': blue,
  'yellow': yellow,
  'lightBlue': lightBlue,
  'green': green,
};

  // prettier-ignore
  const COLORS = {
    'blue': theme.color.blue.default,
    'yellow': theme.color.yellow.default,
    'lightBlue': theme.color.blue.default,
    'green': theme.color.green.default,
  };

  const BUTTON_COLORS: Record<string, ButtonColor> = {
    blue: 'blue',
    yellow: 'yellow',
    lightBlue: 'blue',
    green: 'green',
  };
  const showWhatsappIcon =
    cardTheme === 'green' && [CountryCode.FR, CountryCode.BE, CountryCode.NL].includes(countryCode);

  return (
    <ConditionalWrapper
      condition={!!link}
      wrapper={(wrapperChildren) => <Link to={link as LocationDescriptor}>{wrapperChildren}</Link>}
    >
      <Styled.Card bg={IMAGES[cardTheme]} {...(onClick && { onClick })}>
        <Styled.Title color={COLORS[cardTheme]}>{title}</Styled.Title>
        <Styled.ButtonWrapper>
          <Button
            color={BUTTON_COLORS[cardTheme]}
            shrink
            {...(showWhatsappIcon && { iconLeft: <FaWhatsapp size={20} /> })}
          >
            {translate(`common.buttons.${cardTheme}`)}
          </Button>
        </Styled.ButtonWrapper>
      </Styled.Card>
    </ConditionalWrapper>
  );
};
